(window.aeOnSectionReady || function (fn) { document.addEventListener('DOMContentLoaded', () => fn(document)); })((sectionRoot) => {
  document.querySelectorAll('[data-ae-ingredients-slider]').forEach((slider) => {
    if (slider.dataset.aeBound === 'true') return;
    slider.dataset.aeBound = 'true';
    const viewport = slider.querySelector('[data-ae-ingredients-viewport]');
    const track = slider.querySelector('[data-ae-ingredients-track]');
    const slides = Array.from(track?.children || []);
    const prev = slider.querySelector('[data-ae-ingredients-prev]');
    const next = slider.querySelector('[data-ae-ingredients-next]');
    const progress = slider.querySelector('[data-ae-ingredients-progress]');
    if (!viewport || !track || !slides.length) return;

    let index = 0;
    let timer;
    let dragOffset = 0;
    let isDragging = false;
    let startX = 0;
    let startIndex = 0;
    let dragMoved = false;
    const DRAG_THRESHOLD = 6;

    const slideSize = () => {
      const slide = slides[0];
      const style = getComputedStyle(slide);
      const width = slide.getBoundingClientRect().width;
      const pad = parseFloat(style.paddingLeft || '0');
      return width + pad;
    };

    const visibleCount = () => {
      const width = viewport.getBoundingClientRect().width;
      return Math.max(1, Math.floor(width / slideSize()));
    };

    const maxIndex = () => Math.max(0, slides.length - visibleCount());

    const updateProgress = () => {
      if (!progress) return;
      const total = maxIndex();
      const ratio = total <= 0 ? 1 : (index + visibleCount()) / slides.length;
      const pct = Math.min(1, Math.max(0.12, ratio));
      progress.style.transform = `scaleX(${pct})`;
    };

    const updateArrows = () => {
      if (prev) prev.disabled = index <= 0;
      if (next) next.disabled = index >= maxIndex();
    };

    const apply = (transition = true) => {
      const offset = index * slideSize() - dragOffset;
      track.style.transition = transition ? '' : 'none';
      track.style.transform = `translate3d(${-offset}px, 0, 0)`;
      updateProgress();
      updateArrows();
    };

    const update = () => apply(true);

    const goTo = (newIndex) => {
      index = Math.max(0, Math.min(maxIndex(), newIndex));
      update();
    };

    const start = () => {};
    const stop = () => {};

    prev?.addEventListener('click', () => {
      stop();
      goTo(index - 1);
      start();
    });
    next?.addEventListener('click', () => {
      stop();
      goTo(index + 1);
      start();
    });

    const onPointerDown = (event) => {
      if (event.button != null && event.button !== 0) return;
      stop();
      isDragging = true;
      dragMoved = false;
      startX = event.clientX;
      startIndex = index;
      dragOffset = 0;
      try { viewport.setPointerCapture(event.pointerId); } catch (e) { /* noop */ }
    };

    const onPointerMove = (event) => {
      if (!isDragging) return;
      const dx = event.clientX - startX;
      if (!dragMoved && Math.abs(dx) < DRAG_THRESHOLD) return;
      dragMoved = true;
      dragOffset = dx;
      apply(false);
    };

    const onPointerUp = (event) => {
      if (!isDragging) return;
      const dx = event.clientX - startX;
      try { viewport.releasePointerCapture(event.pointerId); } catch (e) { /* noop */ }
      isDragging = false;

      if (dragMoved) {
        const stepThreshold = slideSize() * 0.2;
        let newIndex = startIndex;
        if (Math.abs(dx) >= stepThreshold) {
          const stepsMoved = Math.round(-dx / slideSize()) || (dx < 0 ? 1 : -1);
          newIndex = Math.max(0, Math.min(maxIndex(), startIndex + stepsMoved));
        }
        index = newIndex;
        dragOffset = 0;
        update();

        const swallow = (e) => {
          e.preventDefault();
          e.stopPropagation();
          viewport.removeEventListener('click', swallow, true);
        };
        viewport.addEventListener('click', swallow, true);
        setTimeout(() => viewport.removeEventListener('click', swallow, true), 50);
      } else {
        dragOffset = 0;
        update();
      }

      start();
    };

    viewport.addEventListener('pointerdown', onPointerDown);
    viewport.addEventListener('pointermove', onPointerMove);
    viewport.addEventListener('pointerup', onPointerUp);
    viewport.addEventListener('pointercancel', onPointerUp);
    viewport.style.touchAction = 'pan-y';

    window.addEventListener('resize', () => {
      index = Math.min(index, maxIndex());
      dragOffset = 0;
      update();
      start();
    });

    update();
    start();
  });
});
